import useDocumentTitle from "@/hooks/useDocumentTitle";
import { DevRoomCanvas } from '@bracesDesigner/devRoom/DevRoomCanvas.tsx';
import { DevPanelUI } from './UI/DevPanelUI';

export const DevRoom = () => {
  useDocumentTitle("DevRoom");
  return (
    <>
      <DevPanelUI />
      <div className={'relative w-full h-full'}>
        <DevRoomCanvas />
      </div>
    </>
  );
};
